import React, {useEffect} from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import {mathRoundDecimal} from "app/React/Util/MathRoundDecimal";

function QuantityField(props){
  const [product] = useEnvValue('product')
  const [minimumQuantity, setMinimumQuantity] = useEnvValue('minimumQuantity',1)
  const [defaultMinimumQuantity] = useEnvValue('defaultMinimumQuantity',1)
  const [selectedVariation] = useEnvValue('selectedVariation', null)
  const [defaultSelectedQuantity] = useEnvValue('defaultSelectedQuantity', 1)
  const [pcsStr] = useEnvValue('strings.pcs')
  const [quantityLabel] = useEnvValue('strings.quantity.label')
  const [amountCalculatorAmount] = useEnvValue('amountCalculatorAmount', '')
  const [selectedQuantity,setSelectedQuantity] = useEnvValue('selectedQuantity', defaultSelectedQuantity)
  const perMeter = typeof selectedVariation === 'object' && selectedVariation !== null ? selectedVariation.perMeter : product.perMeter

  const handleOnChange = function(e){
    let quantity = parseInt(e.target.value)
    if (isNaN(quantity)) {
      quantity = ''
    }

    if(quantity === selectedQuantity) {
      return;
    }

    setSelectedQuantity(isNaN(quantity) ? '' : quantity);
  }

  const calculateRecomendedQuantity = () => {
    let recommendedQuantity = amountCalculatorAmount * mathRoundDecimal(perMeter)
    if (recommendedQuantity < minimumQuantity) recommendedQuantity = minimumQuantity

    if (amountCalculatorAmount === '') {
      recommendedQuantity = defaultSelectedQuantity
    }

    return Math.ceil(recommendedQuantity)
  }

  useEffect(() => {
    if (typeof selectedVariation === 'object' && selectedVariation !== null && selectedVariation.minimum_amount !== null) {
      const amountCalculatorQuantity = amountCalculatorAmount * mathRoundDecimal(perMeter)

      setMinimumQuantity(selectedVariation.minimum_amount)
      if (amountCalculatorQuantity < selectedVariation.minimum_amount || selectedQuantity < selectedVariation.minimum_amount) {
        setSelectedQuantity(selectedVariation.minimum_amount)
        return
      }
    }

    let recomendedQuantity = calculateRecomendedQuantity()
    setMinimumQuantity(defaultMinimumQuantity)

    if(recomendedQuantity !== selectedQuantity) {
      setSelectedQuantity(recomendedQuantity)
    }
  }, [amountCalculatorAmount, defaultSelectedQuantity, minimumQuantity, perMeter, selectedVariation])

  return (
    <div className="quantity">
      <label className="mtt-variations__title">{quantityLabel}</label>
      <input className="input-text qty text postfix-input"
             type="number"
             step="1"
             min={minimumQuantity}
             max="9999"
             name="quantity"
             value={selectedQuantity}
             title="Stk."
             size="4"
             placeholder=""
             inputMode="numeric"
             onChange={handleOnChange}
      />
      {/*<span className="postfix">{pcsStr}</span>*/}
    </div>
  )
}

export default observer(QuantityField)